import React from 'react';
import '../assets/css/about.css'
import AboutSwiper from '../components/about-swiper'
import AboutPart1 from '../components/about/aboutPart1'
import AboutPart2 from '../components/about/aboutPart2'
import AboutPart3 from '../components/about/aboutPart3'
import AboutPart4 from '../components/about/aboutPart4'
import AboutPart5 from '../components/about/aboutPart5'
import Service1 from '../components/home/homePart6'
import EzBottom from '../components/bottom';
import Bottom from '../components/bottom'
import { AboutCustomDataProvider } from './context/aboutCustomDataProvider';

const About: React.FC = () => {
    return (
        <AboutCustomDataProvider>
            <div className='aboutUs'>
                <AboutPart5 />
                <Service1/>
            </div>
                    <Bottom />

        </AboutCustomDataProvider>
    )
};

export default About;   